/**
 * This is the first reducer prepping for adoption of a generic storage model with late access / transformation via selectors.
 */
import { Kaggle } from "@kaggle/sdk";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

type Entity = Kaggle.Sdk.Kernels.Models.KernelDraft;

export type State = Record<any, Entity | null>;

/** Reducer used to manage kernel drafts. */
export const kernelDrafts = (
  state: State = {},
  action: NotebookAction
): State => {
  switch (action.type) {
    case NotebookActionKey.SET_DRAFT_SPEC:
      const { id, entity } = action.payload;
      return { ...state, [id]: entity };
    default:
      return state;
  }
};
